(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.showcasecarouselblock = window.oneadvanced.showcasecarouselblock || {};
    window.oneadvanced.showcasecarouselblock.init = function () {
        //console.log("initialising showcasecarouselblock...");
        var showcaseCarousels = document.querySelectorAll('[data-scc-block-id]');
        if (showcaseCarousels.length) {
            for (var scc = 0; scc < showcaseCarousels.length; scc++) {
                sccHandler(
                    showcaseCarousels[scc].getAttribute('data-scc-block-id'),
                    showcaseCarousels[scc].getAttribute('data-scc-count')
                );
            }
        }
        function sccHandler(blockId, count) {
            'use strict';
            // set a default value for count on the off chance that we haven't added the attribute to the element
            if (!count) {
                count = 3;
            }

            // set initial slide
            var $initial_slide = Math.ceil(count / 2) - 1;
            // console.log("begin on slide index ", $initial_slide);
            var $sliderFor = $("#block" + blockId + " .slider-for");
            var $sliderNav = $("#block" + blockId + " .slider-nav");
            var $scc_init = false;
            var centerMode = false;

            $(window).on('changed.zf.mediaquery load', function (event, newSize, oldSize) {
                if (!newSize) {
                    newSize = Foundation.MediaQuery.current;
                }

                if (newSize == "small") {

                    if ($scc_init) {
                        $sliderFor.slick('unslick');
                        $sliderNav.slick('unslick');

                        $scc_init = false;
                    }

                    $sliderFor.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        asNavFor: $sliderNav,
                        mobileFirst: true,
                        infinite: true,
                        arrows: false,
                        fade: true,
                        dots: false,
                        initialSlide: $initial_slide
                    });
                    $sliderNav.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        asNavFor: $sliderFor,
                        focusOnSelect: true,
                        arrows: false,
                        infinite: true,
                        centerMode: true,
                        variableWidth: true,
                        dots: true,
                        initialSlide: $initial_slide
                    });

                    $scc_init = true;

                } else if (newSize == "medium") {

                    if ($scc_init) {
                        $sliderFor.slick('unslick');
                        $sliderNav.slick('unslick');

                        $scc_init = false;
                    }

                    centerMode = count % 2 !== 0;
                    var slides_to_show;
                    if (centerMode) {
                        slides_to_show = Math.floor(count / 2);
                    } else {
                        slides_to_show = count / 2;
                    }

                    // console.log("centre mode ", centerMode);
                    // console.log("slides to show ", slides_to_show);

                    $sliderFor.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        asNavFor: $sliderNav,
                        mobileFirst: true,
                        infinite: true,
                        arrows: false,
                        fade: true,
                        dots: false,
                        initialSlide: $initial_slide
                    });
                    $sliderNav.slick({
                        slidesToShow: slides_to_show,
                        slidesToScroll: 1,
                        asNavFor: $sliderFor,
                        focusOnSelect: true,
                        arrows: false,
                        infinite: true,
                        centerMode: centerMode,
                        variableWidth: true,
                        dots: true,
                        initialSlide: $initial_slide
                    });

                    $scc_init = true;

                } else {
                    // We're not in 'small' any more Alice

                    if ($scc_init) {
                        $sliderFor.slick('unslick');
                        $sliderNav.slick('unslick');

                        $scc_init = false;
                    }

                    centerMode = count % 2 !== 0;
                    if (!centerMode) {
                        $initial_slide = 0;
                    }

                    // console.log("centre mode ", centerMode);
                    // console.log("count is ", count);

                    $sliderFor.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                        fade: true,
                        asNavFor: $sliderNav,
                        mobileFirst: true,
                        initialSlide: $initial_slide
                    });
                    $sliderNav.slick({
                        slidesToShow: count,
                        slidesToScroll: 1,
                        asNavFor: $sliderFor,
                        dots: false,
                        focusOnSelect: true,
                        arrows: false,
                        infinite: false,
                        centerMode: centerMode,
                        initialSlide: $initial_slide
                    });

                    $scc_init = true;
                }
            });
        }
    };
    window.oneadvanced.showcasecarouselblock.hasLoaded = true;

})();